import { Row, Col } from "antd";
import Title from "components/Features/Financeiro/FormConta/components/Title";
import { AiOutlinePlusCircle } from "react-icons/ai";
import colors from "core/resources/theme/colors";
import { Control, ControllerRenderProps } from "react-hook-form";
import { ManutencaoForm } from "features/manutencao/typings/index";
import ModalSelectEquipamento from "./../ModalSelectEquipamento/index";
import { useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
import Field from "components/Input/Field/index";
import { FaRegTimesCircle } from "react-icons/fa";
import SelectEquipamento from "components/Input/SelectEquipamento";
import { FormLabel } from "@chakra-ui/form-control";
import { EquipamentoForm } from "features/equipamento/typings";
import { UseFormSetValue } from "react-hook-form";

interface AdicionarEquipamentoProps {
  control: Control<ManutencaoForm>;
  form: ManutencaoForm;
  setValue: UseFormSetValue<ManutencaoForm>;
}

const Label = ({ text, textAlign }: { text: string; textAlign?: any }) => (
  <FormLabel
    textAlign={textAlign ? textAlign : "left"}
    color="gray.600"
    fontWeight="400"
    fontSize="sm"
    noOfLines={1}
  >
    {text}*
  </FormLabel>
);

export default function AdicionarEquipamento({
  control,
  form,
  setValue,
}: AdicionarEquipamentoProps) {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const onEditRow = (
    field: ControllerRenderProps<any, any>,
    value: Partial<EquipamentoForm>,
    index: number
  ) => {
    const copy = [...field.value];

    copy.splice(index, 1, value);

    field.onChange(copy);
  };
  const onRemoveItem = (
    field: ControllerRenderProps<any, any>,
    index: number
  ) => {
    const copy = [...field.value];

    copy.splice(index, 1);

    field.onChange(copy);
  };
  return (
    <>
      <Row align="middle">
        <Col>
          <Title label="Patrimônios" mt={6} />
        </Col>
        <Col style={{ marginLeft: "10px" }}>
          <AiOutlinePlusCircle
            fontSize={28}
            color={colors.primary}
            onClick={() => setIsOpenModal(true)}
            cursor="pointer"
          />
        </Col>
      </Row>

      <Box mb={4}>
        <Field
          control={control}
          name="equipamentosIds"
          rules={{
            required: {
              value: true,
              message: "Informe pelo menos um equipamento",
            },
            validate: (v) =>
              v.every((item: string | undefined) => !!item) ||
              "Todos os equipamentos devem estar preenchidos",
          }}
          render={({ field, isInvalid }) => (
            <>
              {field.value?.map((equipamento: string, index: number) => (
                <Flex alignItems="center" key={index} mb={3}>
                  <Box flex={3}>
                    {index === 0 ? <Label text="Equipamento" /> : null}
                    <SelectEquipamento
                      value={equipamento}
                      placeholder="Selecione..."
                      onChange={(v) => onEditRow(field, v, index)}
                      isInvalid={isInvalid && !equipamento}
                    />
                  </Box>

                  {field.value.length > 1 ? (
                    <Flex
                      mt={index === 0 ? 7 : 0}
                      flex={0.3}
                      justifyContent="flex-end"
                      cursor="pointer"
                      onClick={() => onRemoveItem(field, index)}
                    >
                      <FaRegTimesCircle color={colors.red} size={24} />
                    </Flex>
                  ) : null}
                </Flex>
              ))}
            </>
          )}
        />
      </Box>

      <ModalSelectEquipamento
        onClose={() => setIsOpenModal(false)}
        onSubmit={(item) => {
          const items = form.equipamentosIds;

          const newItems = items.concat(item);

          setValue("equipamentosIds", newItems);

          setIsOpenModal(false);
        }}
        visible={isOpenModal}
      />
    </>
  );
}
